import axios from '../index'
import { GetSubscriptionList, SubscriptionDetail } from './types'

export const getSubscriptionsList = (variables?: GetSubscriptionList) => {
  return axios.get<SubscriptionDetail[]>(`/api/v1/subscription/`, { params: { ...variables } }).then(res => res.data)
}
